import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { oneClickAuthorize, customAppAuthorize } from 'services/ShopifyIntegrationService'
import { useDispatch } from 'react-redux'
import { Success, Error } from 'utils/alerts'
import ShopifyForm from './components/ShopifyForm'
import { getCompanyData, getCustomersData } from 'store/data/dataSlice'

const Create = ({ view, setOpen, setSelectedData }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        // Explicitly load company and customer data for dropdowns
        dispatch(getCompanyData())
        dispatch(getCustomersData())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleDiscard = () => {
        setOpen(false)
        setSelectedData()
    }

    const handleSubmit = data => {
        // Determine which authorization method to use based on integration type
        const authorizationData = {
            company_id: data.company_id,
            customer_id: data.customer_id,
            shop_name: data.shop_name,
        }

        // let authPromise

        if (data.integration_type === 'custom_app') {
            // Add custom app specific fields
            authorizationData.api_key = data.api_key
            authorizationData.api_secret = data.api_secret
            authorizationData.access_token = data.access_token
            authorizationData.scopes =
                data.scopes ||
                'write_assigned_fulfillment_orders,read_assigned_fulfillment_orders,read_fulfillments,write_fulfillments,write_inventory,read_inventory,write_locations,read_locations,write_orders,read_orders,read_products,write_products,read_shipping,write_shipping,read_customers,write_merchant_managed_fulfillment_orders,read_merchant_managed_fulfillment_orders,write_third_party_fulfillment_orders,read_third_party_fulfillment_orders'

            // For custom app, handle the response directly without redirect
            customAppAuthorize(authorizationData)
                .then(response => {
                    console.log('Custom app integration response:', response.data)
                    if (response.data?.success && response.data?.redirect_required === false) {
                        Success(`Custom app integration created successfully for ${response.data.shop_domain}!`)
                        // Navigate back to the integration list
                        navigate('/company-management/shopify-integration')
                    } else if (response.data?.authorization_url) {
                        // Fallback: if for some reason an authorization URL is returned, redirect
                        window.open(response.data.authorization_url, '_self')
                    } else {
                        Error('Failed to create custom app integration')
                    }
                })
                .catch(error => {
                    console.error('Error creating custom app integration:', error)
                    const errorMessage = error.response?.data?.error || 'Failed to create custom app integration'
                    Error(errorMessage)
                })
        } else {
            // Use one-click authorization flow (existing behavior)
            oneClickAuthorize(authorizationData)
                .then(response => {
                    console.log('One-click authorization response:', response.data)
                    if (response.data?.authorization_url) {
                        window.open(response.data.authorization_url, '_self')
                    } else {
                        Error('Failed to generate authorization URL')
                    }
                })
                .catch(error => {
                    console.error('Error starting Shopify authorization:', error)
                    const errorMessage = error.response?.data?.error || 'Failed to start Shopify integration'
                    Error(errorMessage)
                })
        }
    }

    return (
        <>
            {/* <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Shopify Integration</h2>
            </div> */}
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    {/* <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">Add New Shopify Integration</h3>
                    </div> */}
                    <div className="flex flex-col gap-3 p-6">
                        <ShopifyForm initialValues={view} onSubmit={handleSubmit} onCancel={handleDiscard} isEdit={false} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
